import { render, staticRenderFns } from "./restoran-dostava.vue?vue&type=template&id=6429139c"
import script from "./restoran-dostava.vue?vue&type=script&lang=js"
export * from "./restoran-dostava.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports